module.exports = __webpack_public_path__ + "img/gaofen_grade_bg.7347b8b5.png";